import { render } from "./NoteSidebar.vue?vue&type=template&id=1eb39ad4&scoped=true"
import script from "./NoteSidebar.vue?vue&type=script&lang=js"
export * from "./NoteSidebar.vue?vue&type=script&lang=js"

import "./NoteSidebar.vue?vue&type=style&index=0&id=1eb39ad4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb39ad4"]])

export default __exports__